exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-534ea392&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/layout/elements/classification-stars.vue
// module id = 358
// module chunks = 0